'use client';

import { getOr } from '@/utils/options';
import clsx from 'clsx';
import { Paragraph } from 'components/src/typography';
import Image from 'next/image';
import Link from 'next/link';
import * as React from 'react';
import { NavbarLinkWithDescriptionFieldsFragment } from 'types/generated';
import { motion } from 'framer-motion';
import { useSetAtom } from 'jotai';
import { isFullscreenExhaustedAtom } from '@/store';

type Props = {
  data: NavbarLinkWithDescriptionFieldsFragment | null;
  showMobileMenu?: boolean;
};

const MotionLink = motion.create(Link);
const MotionParagraph = motion.create(Paragraph);

const LinkWithDescription = ({ data, showMobileMenu }: Props) => {
  const setIsFullscreenExhausted = useSetAtom(isFullscreenExhaustedAtom);
  if (!data) return null;
  return (
    <motion.div
      layout="position"
      className={clsx('flex pt-sm align-top flex-col sm:flex-row gap-sm', {
        'items-start self-stretch pb-lg pt-sm': showMobileMenu,
        'p-lg': !showMobileMenu,
      })}
    >
      <div className="-mt-1 grid !h-[32px] !w-[32px] min-w-[32px] content-center items-center justify-items-center rounded-full bg-white-50 p-xs ">
        <Image src={getOr(data.icon?.url, '')} alt="" width={18} height={18} />
      </div>
      <div className="flex flex-col">
        <div className="flex items-center gap-8">
          <MotionLink
            href={getOr(data.uri, '')}
            className={clsx('headline-sm font-bold text-white-75', showMobileMenu ? 'text-md-fixed' : 'text-md')}
            onClick={() => {
              setIsFullscreenExhausted(true);
              document.body.classList.remove('overflow-y-hidden');
            }}
          >
            <motion.div layout="position" className="hover:underline">
              {data.title}
            </motion.div>
          </MotionLink>
        </div>
        <MotionParagraph layout="position" variant="medium" classes="body-md flex text-white-75">
          {getOr(data.description, '')}
        </MotionParagraph>
      </div>
    </motion.div>
  );
};

export default LinkWithDescription;
